








































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import {Component, Prop, PropSync} from "vue-property-decorator";
import {Options} from "@/plugins/print/lib/print";
import {getPublicPath} from "@/shared/services/helper/utils";
import TableToExcel from "@linways/table-to-excel";
import ManageFeeCustomerPayedPrint from "@/modules/managefeecustomer/ListPayed/components/Print/index.vue";
import ManageFeeCustomerPayedExcel from "@/modules/managefeecustomer/ListPayed/components/Excel/index.vue";

@Component({
    name: "ManageFeeCustomerPayedDetail",
    components: {
        ManageFeeCustomerPayedExcel,
        ManageFeeCustomerPayedPrint,
    }
})
export default class extends mixins(CommonMixin) {
    @PropSync("visible",{ type: Boolean, default: false }) syncVisible!: boolean;
    @Prop({ required: true }) id!: any;

    printPickingListObj: Options = {
        id: 'table-print-detail-payed',
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`
    };

    printPickingList() {
        this.$print(this.printPickingListObj);
    }

    exportExcel() {
        TableToExcel.convert(document.getElementById("table-excel-detail-payed"), {
            name: `Bảng kê chi tiết.xlsx`,
            sheet: {
                name: "Sheet 1"
            }
        });
    }
}
